import { number, object } from 'yup';
import { WizardState } from '../../../../context/SetGoalProvider';

export type FormValues = WizardState['expense'];

export const validation = object({
  amount: number()
    .nullable()
    .required('Please, specify an amount'),
  startDate: number()
    .nullable()
    .required('Required'),
  saveEvery: number()
    .nullable()
    .required('Required'),
  saveForLength: number()
    .nullable()
    .required('Required'),
  saveForPeriod: number()
    .nullable()
    .required('Required'),
});
